module.exports = __webpack_public_path__ + "img/clock-seven.2025da71.svg";